import { api } from './client'

/**
 * Корпоративный чат.
 *
 * Пути повторяют роутер chat.py. Отправка — multipart: очередь
 * на устройстве собирает FormData из текста и фото в момент
 * фактической отправки, и клиентский код обязан передавать
 * clientMessageId, сгенерированный ОДИН раз при постановке
 * в очередь: повтор с тем же ключом сервер отвечает 200
 * с уже созданным сообщением.
 */
export const chatApi = {
  conversations: () => api.get('/chat/conversations'),

  createDirect: (userId) =>
    api.post('/chat/conversations', { kind: 'direct', user_id: userId }),

  createGroup: ({ title, memberIds = [], regionId = null }) =>
    api.post('/chat/conversations', {
      kind: 'group',
      title,
      member_ids: memberIds,
      region_id: regionId,
    }),

  conversation: (id) => api.get(`/chat/conversations/${id}`),

  updateConversation: (id, data) => api.patch(`/chat/conversations/${id}`, data),

  messages: (id, { beforeId } = {}) =>
    api.get(`/chat/conversations/${id}/messages`, {
      params: beforeId ? { before_id: beforeId } : {},
    }),

  /**
   * @param {FormData} form — body, client_message_id, reply_to_id?, file_0..N
   */
  sendMessage: (id, form) =>
    api.post(`/chat/conversations/${id}/messages`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  markRead: (id, messageId) =>
    api.post(`/chat/conversations/${id}/read`, { message_id: messageId }),

  pin: (messageId) => api.post(`/chat/messages/${messageId}/pin`),
  unpin: (messageId) => api.post(`/chat/messages/${messageId}/unpin`),
  save: (messageId) => api.post(`/chat/messages/${messageId}/save`),
  unsave: (messageId) => api.post(`/chat/messages/${messageId}/unsave`),
  saved: () => api.get('/chat/saved'),

  attachmentUrl: (attachmentId, kind = 'full') =>
    api.get(`/chat/attachments/${attachmentId}/url`, { params: { kind } }),

  conversationAttachments: (id, limit = 60) =>
    api.get(`/chat/conversations/${id}/attachments`, { params: { limit } }),
}

/** Подписки Web Push — роутер push.py. */
export const pushApi = {
  publicKey: () => api.get('/push/public-key'),
  subscribe: (subscription) => api.post('/push/subscription', subscription),
  unsubscribe: (endpoint) => api.delete('/push/subscription', { data: { endpoint } }),
}
